export default __webpack_public_path__ + "2517067f5aa23a55c12fd30b378f2ebe.png";